<template>
  <div class="content">
    <div class="contentBox">
      <img class="leftBgImg" :src="adminLoginPics" alt="" />

      <div class="box_log loginbox">
        <div class="main">
          <div class="top">
            <!-- <div class="topTit">
              <img class="logostyleRx" src="../assets/img/rxlogo.png" alt="" />
              <div class="titleRX">荣祥物流</div>
            </div> -->

            <!-- 荣祥logo -->
            <!-- <img class="logostyle2" src="../assets/img/logoA.png" alt="" /> -->
            <!-- 动态logo -->
            <img class="logostyle2" :src="adminLoginlogoUrl" alt="" />
            <!-- <img
              v-if="!isTest"
              class="logostyle2"
              src="../assets/img/tmsIcon/huaYuanlogo.png"
              alt=""
            /> -->
          </div>
          <h3 class="tips_tit">用户登录</h3>
          <!-- 账号登录 -->
          <el-form
            @submit.native.prevent
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0"
            class="demo-ruleForm"
          >
            <el-form-item prop="userName" class="rowItem">
              <el-input
                class="loginInput"
                placeholder="登录账号"
                v-model="ruleForm.userName"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="password" class="rowItem">
              <el-input
                class="loginInput"
                placeholder="登录密码"
                type="password"
                v-model="ruleForm.password"
                show-password
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <div>
              <el-form-item prop="EnterpriseNo" class="rowItem">
                <el-input
                  class="loginInput"
                  placeholder="企业编号"
                  v-model="ruleForm.EnterpriseNo"
                  @blur="getAdminLoginPic"
                ></el-input>
              </el-form-item>
            </div>

            <el-form-item style="text-align: center">
              <el-button class="subBtn" type="primary" @click="submitForm()"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tools from "@/assets/js/tool";
// import { parse } from "qs";
export default {
  data() {
    var checkUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不能为空"));
      }
      callback();
    };
    var checkUserName2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不能为空"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
      callback();
    };
    return {
      ruleForm: {
        password: "",
        userName: "",
        sign: "",
        EnterpriseNo: "",
      },
      ruleForm2: {
        code: "",
        userName: "",
        prefix: "",
        sign: "",
      },

      rules: {
        password: [{ validator: validatePass, trigger: ["blur", "change"] }],
        userName: [{ validator: checkUserName, trigger: ["blur", "change"] }],
        EnterpriseNo: [
          { validator: checkUserName, trigger: ["blur", "change"] },
        ],
      },
      rules2: {
        code: [{ validator: validateCode, trigger: "blur" }],
        userName2: [{ validator: checkUserName2, trigger: "blur" }],
      },

      codeStatus: false, //true == 正在获取验证码 false == 没有在倒计时

      UserData: {}, //租户信息
      userType: "", //租户
      // adminLoginlogoUrl: "../assets/img/logoA.png",
      adminLoginPics: "",
      // adminLoginPics: "../assets/img/bgImg.png",
      adminLoginlogoUrl: "../assets/img/bgImg.png",

      isTest: false,
    };
  },
  //页面卸载
  Destroyed() {},
  watch: {},
  created() {
    // let DomainName = tools.getDomainName();

    let uk = window.localStorage.getItem("UserKey") || "";
    let ifReLogin = window.localStorage.getItem("ifReLogin") || false; //是否是重新登陆
    if (uk && !ifReLogin) {
      this.$router.push("/baseIndex");
    }
    // if (this.$COMMON.isTest) {
    //   this.isTest = true;
    //   // document.title = "八米TMS";
    //   // document.title = "荣祥物流";
    //   // document.title = "牵引TMS";
    // } else {
    // }
    // document.title = "八米TMS";
    // document.title = "荣祥物流TMS";
  },
  mounted() {
    // this.$keyBoard(this, "onClickEnter", 13);
    if (window.localStorage.getItem("userList")) {
      let userList = JSON.parse(window.localStorage.getItem("userList"));

      this.ruleForm.userName = userList[0].userName;
      this.ruleForm.password = decodeURIComponent(userList[0].password);
    }

    this.ruleForm.EnterpriseNo =
      window.localStorage.getItem("EnterpriseNo") || "";
    if (!this.ruleForm.EnterpriseNo) {
      this.open();
    } else {
      this.getAdminLoginPic();
    }
    this.endPlay()
  },
  methods: {
    getAdminLoginPic() {
      if (!this.ruleForm.EnterpriseNo) {
        return false;
      }
      window.localStorage.setItem("EnterpriseNo", this.ruleForm.EnterpriseNo);
      // 获取租户登陆页信息
      this.$API.getAdminLoginPic().then((res) => {
        let datas = res.data.result || "";
        if (datas && datas.tenantSystemName) {
          document.title = datas.tenantSystemName || "八米TMS"; //网页浏览器卡片标题
          window.localStorage.setItem("tenantSystemName", datas.tenantSystemName);
        }
        if (datas && datas.adminLoginlogoUrl) {
          this.adminLoginlogoUrl = datas.adminLoginlogoUrl; //
        }
        // if (datas && datas.adminLoginPics.length > 0) {
        //   this.adminLoginPics = datas.adminLoginPics[0]; //
        // }
      });
    },
    // 获取租户应用信息
    getTenantApp() {
      var param = {
        appStatus: "admin:app_status",
        domainName: "b9.admin.xhyitsoft.com",
      };
      this.$API.getTenantApp(param).then((res) => {
        if (res.data.status == "success") {
          this.UserData = res.data.result || {};
        }
      });
    },

    open() {
      this.$prompt("请输入企业编号", "提示", {
        confirmButtonText: "确定",
        inputPattern: /^[a-zA-Z0-9]{2,}/,
        inputErrorMessage: "企业编号格式不正确",
        showCancelButton: false,
      })
        .then(({ value }) => {
          this.ruleForm.EnterpriseNo = value;
          window.localStorage.setItem("EnterpriseNo", value);
          this.getAdminLoginPic();
        })
        .catch(() => {});
    },
    // 切换
    open2() {
      this.$prompt("请输入企业编号", "提示", {
        confirmButtonText: "确定",
        inputPattern: /^[a-zA-Z0-9]{3,}/,
        inputErrorMessage: "企业编号格式不正确",
        inputPlaceholder: this.ruleForm.EnterpriseNo || "请输入",
      })
        .then(({ value }) => {
          this.ruleForm.EnterpriseNo = value;
          window.localStorage.setItem("EnterpriseNo", value);
          this.getAdminLoginPic();
        })
        .catch(() => {});
    },

    submitForm() {
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          window.localStorage.setItem(
            "EnterpriseNo",
            that.ruleForm.EnterpriseNo
          );
          let param = {
            password: that.ruleForm.password,
            userName: that.ruleForm.userName,
          };
          let uesrarray = {
            password: encodeURIComponent(that.ruleForm.password),
            userName: that.ruleForm.userName,
          };
          window.localStorage.setItem("UserKey", "");
          that.$API.wtl_oauthAdmin(param).then((res) => {
            that.$message.success(res.data.message || "登录成功");
            window.localStorage.setItem("UserKey", res.data.result.userKey);
            window.localStorage.setItem("ifReLogin", false); //用来判断是否是登录失效后跳转到登录页
            //账号缓存
            let userList = [];
            if (JSON.parse(window.localStorage.getItem("userList"))) {
              userList = JSON.parse(window.localStorage.getItem("userList"));

              userList[0].userName = uesrarray.userName;
              userList[0].password = uesrarray.password || "";
              window.localStorage.setItem("userList", JSON.stringify(userList));
            } else {
              //第一次缓存
              userList.push(uesrarray);
              window.localStorage.setItem("userList", JSON.stringify(userList));
            }
            this.startPlay()
            setTimeout(() => {
              that.$router.push({
                path: "/baseIndex",
              });
            }, 1000);
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang='less'>
@myColor: #ef7c1b;

body {
  margin: 0;
  padding: 0 !important;
}

.content {
  // background: url("../assets/img/bgc3.jpg") no-repeat;
  //background: url("../assets/img/bgc1.jpg") no-repeat;
  background: url("../assets/img/bgc2.png") no-repeat;
  background-size: 100% 100%;
  background-color: #f2f2f2;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.contentBox {
  width: 90%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  // justify-content: flex-end;
  margin: 0 auto;
  box-sizing: border-box;

  .loginbox {
    .el-input__inner {
      // border-bottom: 1px solid #d7d7d7;

      height: 40px;
      line-height: 40px;
      min-height: 40px;
    }
  }

  .leftBgImg {
    flex: 1;
    min-width: 400px;
    max-width: 600px;
    margin-right: 100px;
    // height: 540px;
  }

  .box_log {
    // width: 25%;
    min-width: 400px;
    max-width: 600px;
    // margin: 0 auto;
    width: 400px;

    margin-right: 80px;

    .main {
      width: 100%;
      border-radius: 6px;
      box-shadow: 0 0 10px #d7d7d7;
      // height: 360px;
      background-color: #fff;
      // box-shadow: 3px 3px 6px #f2f2f2;
      box-sizing: border-box;
      padding: 30px 50px 10px 50px;

      .top {
        width: 100%;

        // background-color: #f00;
        // position: relative;
        // display: flex;
        // align-items: center;
        position: relative;
        text-align: center;

        .logoIcon {
          width: 60px;
          height: 60px;
          margin-right: 56px;
          position: absolute;
          left: 0;
          top: 20px;
        }

        .logostyle {
          width: 70%;
        }

        .logostyle2 {
          // width: 70%;
          height: 70px;
        }

        .topTit {
          display: flex;
          align-items: center;

          .logostyleRx {
            width: 80px;
          }
          .titleRX {
            flex: 1;
            text-align: left;
            font-weight: bold;
            font-size: 32px;
            margin-left: 20px;
          }
        }

        .title {
          // width: 100%;
          // flex: 1;
          text-align: center;
        }
      }

      .subBtn {
        margin: 20px auto;
        background-color: #ef7c1b;
        width: 100%;
      }

      .el-button {
        border: 0;
        padding: 15px 0;
      }
    }
  }

  ::v-deep {
    .el-input__inner {
      height: 40px;
      line-height: 40px;
      min-height: 40px;
    }
  }

  .rowItem {
    // border: 1px solid #d7d7d7;
    margin-bottom: 20px;
  }

  .rowCode {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .loginInput {
      flex: 1;
    }

    .activeClass {
      margin: 0;
      padding: 0 8px;
      margin-left: 10px;
      height: 38px;
      line-height: 38px;
      border: none;
      color: #fff;
      background-color: @myColor;
      border-radius: 4px;
      width: 86px;
    }

    .getCodeBtn {
      margin: 0;
      padding: 0 8px;
      margin-left: 10px;
      height: 38px;
      line-height: 38px;
      border-radius: 4px;
      width: 86px;
      border: 1px solid #d7d7d7;
      color: #333;
    }
  }
}
</style>